import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ui-section-header-title]',
})
export class UiSectionTitleDirective {
  constructor() {}
  @HostBinding('class') elClass = 'ui-section-header-title';
}
